if($('.objednavkovy-form').length){
    $(document).on('submit', '.objednavkovy-form', function(e) {
        e.preventDefault();
        const $form = $(this);
        $form.addClass('loading-form');

        let isValid = true;

        // Základní validace vstupů
        const jmeno = $form.find('#jmeno').val().trim();
        const adresa = $form.find('#adresa').val().trim();
        const email = $form.find('#email').val().trim();
        const telefon = $form.find('#telefon').val().trim();
        const termin = $form.find('input[name="termin"]:checked').val();
        const doprava = $form.find('input[name="doprava"]:checked').val();
        const platba = $form.find('input[name="platba"]:checked').val();
        const tvar = $form.find('input[name="tvar"]:checked').val();
        const pouziti = $form.find('input[name="pouziti"]:checked').val();
        const pocet = $form.find('#pocet').val();
        const velikost = $form.find('input[name="velikost"]:checked').val();
        const poznamka = $form.find('#poznamka').val().trim();
        const souhlas = $form.find('input[name="souhlas"]').is(':checked');
        const motivFile = $form.find('#motiv')[0].files[0];

        // Povinná pole
        if (jmeno === '') { alert('Zadejte jméno a příjmení.'); isValid = false; }
        if (email === '') { alert('Zadejte e-mail.'); isValid = false; }
        if (!souhlas) { alert('Musíte souhlasit s podmínkami.'); isValid = false; }

        if (!isValid) {
            $form.removeClass('loading-form');
            return;
        }

        // FormData pro odeslání
        const formData = new FormData();
        formData.append('jmeno', jmeno);
        formData.append('adresa', adresa);
        formData.append('email', email);
        formData.append('telefon', telefon);
        formData.append('termin', termin);
        formData.append('doprava', doprava);
        formData.append('platba', platba);
        formData.append('tvar', tvar);
        formData.append('pouziti', pouziti);
        formData.append('pocet', pocet);
        formData.append('velikost', velikost);
        formData.append('poznamka', poznamka);
        if (motivFile) formData.append('motiv', motivFile);
        fetch('https://tools.shopcode.cz/e-mail_sender/vykrajovatka/www/', {
            method: 'POST',
            body: formData
        })
        .then(res => res.json())
        .then(result => {
            if (result.status === 'ok') {
                showMessage('Formulář byl úspěšně odeslán. Děkujeme!', 'success', '', false, true);
                $form[0].reset();
            } else {
                showMessage('Došlo k chybě při odesílání. Zkuste to prosím znovu.', 'error', '', false, true);
            }
            $form.removeClass('loading-form');
        })
        .catch(error => {
            console.error('Chyba:', error);
            showMessage('Došlo k technické chybě. Zkuste to později.', 'error', '', false, true);
            $form.removeClass('loading-form');
        });
    });
}

$('#motiv').on('change', function () {
    const file = this.files[0];

    if (file) {
        $('#motiv-filename').text("Vybraný soubor: " + file.name);
    } else {
        $('#motiv-filename').text("");
    }
});